import { grey } from '@material-ui/core/colors';

export default {
  gridItem: { padding: 5 },
  textField: {
    marginLeft: 10,
    marginRight: 5,
    marginTop: 0,
    marginBottom: 0,
    width: 200,
  },
  displayFlex: {
    flex: 1,
    flexDirection: 'column',
    display: 'flex',
  },
  flex: { flex: 1 },
  header: {
    marginBottom: 15,
    display: 'flex',
    alignItems: 'center',
  },
  treeContainer: {
    flex: 1,
    flexDirection: 'column',
    display: 'flex',
    background: grey[100],
  },
};
